/* eslint-disable no-use-before-define */
import { arrayFrom, arrayRemove, arrayUnique, cleanObject, isEmpty, isString } from '../twd'

export const fixParams = (values) => {

    var p = { ...(values || {}) }

    if (p.holdIdentifierLabel === 'holdIsin') {
        p.holdIsin = getUniqueTexts(p.holdIdentifiers)
        p.holdIsinExclude = p.holdCusipExclude
    }
    if (p.holdIdentifierLabel === 'holdCusip') {
        p.holdCusip = getUniqueTexts(p.holdIdentifiers)
    }

    p.holdIssue = getUniqueTexts(p.holdIssue)
    p.holdIssueSp = getUniqueTexts(p.holdIssueSp)
    p.holdSymbol = getUniqueTexts(p.holdSymbol)
    p.holdSymbolPref = getUniqueTexts(p.holdSymbolPref)
    p.holdSymbolSp = getUniqueTexts(p.holdSymbolSp)


    let invTypes = arrayFrom(p.holdInvType)
    var cf

    cf = arrayFrom(p.holdCallFeatures)
    fixParam(cf, p, 'holdCallableInd')
    fixParam(cf, p, 'holdWholeCallInd')
    fixParam(cf, p, 'holdPutableInd')
    fixParam(cf, p, 'holdPutType')
    if (isEmpty(p.holdPutableInd)) p.holdPutType = []
    fixParam(cf, p, 'holdErpInd')
    fixParam(cf, p, 'holdErpInd')
    if (isEmpty(p.holdErpInd)) p.holdErpInd = []
    fixParam(cf, p, 'holdNextSink')
    fixParam(cf, p, 'holdSinkType')


    if (invTypes.indexOf('M')<0) {
        p.holdMuniTypePurpose = []
        p.holdMuniPurpose = []
        p.holdState = []
        p.holdTaxability = []
        p.holdCorpBacked = []
        p.holdCorporationName = []
        p.holdInsurance = []
    } else {
        cf = arrayFrom(p.holdMuniTypePurpose)
        fixParam(cf, p, 'holdMuniType')
        fixParam(cf, p, 'holdBankQualified')
        fixParam(cf, p, 'holdRefundInd')
        fixParam(cf, p, 'holdRefundType')
        if (isEmpty(p.holdRefundInd)) p.holdRefundType = []
        fixParam(cf, p, 'holdRevenueType')
        fixParam(cf, p, 'holdFinancingInd')
        p.holdInsurance = isEmpty(p.holdInsurance)
            ? arrayFrom(p.holdInsurance)
            : p.holdInsurance

        cf = arrayFrom(p.holdMuniPurpose)
        fixParam(cf, p, 'holdUseOfProceeds')
        fixParam(cf, p, 'holdIssueType')

        cf = arrayFrom(p.holdTaxability)
        fixParam(cf, p, 'holdTaxable')
        fixParam(cf, p, 'holdStateTaxExempt')
        fixParam(cf, p, 'holdAltMinTax')
    }

    if (invTypes.indexOf('C')<0) {
        p.holdCorpTypeValues = []
        p.holdIndustryCode = []
        p.holdCorpSectorCode = []
        p.holdBlueSkyState = []
        p.holdRegS = []
        p.holdReligiousOrg = []
        p.holdSeasonedRegS = []
        p.holdCorpType = []
        p.holdCorpDebtRanking = []
        p.holdSymbol = []
        p.holdConvertible = []
        p.holdDrnk = []
    } else {
        cf = arrayFrom(p.holdCorpTypeValues)
        fixParam(cf, p, 'holdRegS')
        fixParam(cf, p, 'holdReligiousOrg')
        fixParam(cf, p, 'holdConvertible')
        fixParam(cf, p, 'holdSeasonedRegS')
        fixParam(cf, p, 'holdCorpType')
    }

    if (invTypes.indexOf('A')<0) {
        p.holdAgencyType = []
    }

    if (invTypes.indexOf('T')<0) {
        p.holdTreasuryType = []
    }

    if (invTypes.indexOf('S')<0) {
        p.holdIDCRankMax = []
        p.holdIDCRankMin = []
        p.holdFedFisRatingMax = []
        p.holdFedFisRatingMin = []
        p.holdFdicNum = []
        p.holdBlueSkyStateCD = []
    }

    if (invTypes.indexOf('P')<0) {
        p.holdHybridCapital = []
        p.holdDrnkPref = []
        p.holdSymbolPref = []
        p.holdPrefSectorCode = []
    }

    if (invTypes.indexOf('L')<0) {
        p.holdSymbolSp = []
        p.holdIssueSp = []
        p.holdIDCRankSpMax = []
        p.holdIDCRankSpMin = []
        p.holdParticipationClass = []
        p.holdPrincipalStatus = []
        p.holdStructType = []
    }

    let labels = [
        'holdAcqYtw',
        'portTotalValue',
        'portAvgDuration',
        'portTotalCashValue',
        'portCountValue',
        'offerYtw',
        'offerYtc',
        'offerYtm',
        'duration',
        'convexity'
    ]

    labels.forEach(l => {
        let n = p[l + 'Label']
        if (!n) return

        if (!p.hasOwnProperty( n + 'Min')) {
            p[n + 'Min'] = p[l + 'Min']
        }
        if (!p.hasOwnProperty(n + 'Max')) {
            p[n + 'Max'] = p[l + 'Max']
        }

        delete p[l + 'Label']
    })

    if (Array.isArray(p.holdRatingWatch) && p.holdRatingWatch.length>0) {
        let arr = p.holdRatingWatch
        p.holdRatingWatchMoodySpAndOr = arr.indexOf('MDY_AND') ? 'AND' : 'OR'
        p.holdRatingWatchSpFitchAndOr = arr.indexOf('SP_AND') ? 'AND' : 'OR'
        arrayRemove(arr, 'MDY_AND')
        arrayRemove(arr, 'SP_AND')
    }

    if (Array.isArray(p.holdRatingOutlook) && p.holdRatingOutlook.length>0) {
        let arr = p.holdRatingOutlook
        p.holdRatingOutlookMoodySpAndOr = arr.indexOf('MDY_AND') ? 'AND' : 'OR'
        arrayRemove(arr, 'MDY_AND')
    }

    if (!isEmpty(p.holdCorpType)) {
        let arr = p.holdCorpType
        let hasForeign = arr.indexOf('Supranational')>=0
                || arr.indexOf('Emerging')>=0
        if (hasForeign) {
            arrayRemove(arr, 'Foreign')
        }
    }

    return cleanObject(p)
}

let fixParam = (cf, p, id) => {
    p[id] = p[id] || collectCriteria(cf, id + '-')
    return p[id]
}

let getUniqueTexts = (a) => {
    if (Array.isArray(a)) return a

    if (!isString(a)) return []

    let s = a.split(',').map(a => a.trim()).filter(Boolean)
    return arrayUnique(s)
}

let collectCriteria = (array,prefix) => {
    let n = prefix.length
    return arrayFrom(array)
        .filter((a) => {
            return (a || "").indexOf(prefix)===0
        })
        .map((a) => a.substring(n))
}


// WEBPACK FOOTER //
// ./src/offerings/fix-params.js